import { render, staticRenderFns } from "./modalDescuentos.vue?vue&type=template&id=3be1d64e&scoped=true&"
import script from "./modalDescuentos.vue?vue&type=script&lang=js&"
export * from "./modalDescuentos.vue?vue&type=script&lang=js&"
import style0 from "./modalDescuentos.vue?vue&type=style&index=0&id=3be1d64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1d64e",
  null
  
)

export default component.exports